/** CPF: validação dos dígitos verificadores, normalização (só dígitos) e formatação para exibição. */

/** Mantém só os dígitos (aceita "123.456.789-09", "12345678909" etc.). */
export const normalizeCpf = (value: string) => value.replace(/\D/g, '');

/** 11 dígitos, não todos iguais e com os dois dígitos verificadores corretos. */
export function isValidCpf(value: string): boolean {
  const d = normalizeCpf(value);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const digit = (len: number) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += Number(d[i]) * (len + 1 - i);
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };
  return digit(9) === Number(d[9]) && digit(10) === Number(d[10]);
}

/** "12345678909" → "123.456.789-09" (formata o que houver enquanto se digita). */
export function formatCpf(value: string): string {
  const d = normalizeCpf(value).slice(0, 11);
  return d
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
}

/** Exibição parcial (LGPD): "***.456.789-**". */
export function maskCpf(value: string): string {
  const d = normalizeCpf(value);
  return d.length === 11 ? `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**` : '';
}
